import { Nullable } from '@src/types/utils';

export interface ContactsCustomListItem {
  id: Nullable<string>;
  title: string;
  sortOrder: number;
}
